// Função de arredondamento inteligente (máximo 3 casas decimais, remove zeros à direita)
const smartRound = (value, maxDecimals = 3) => {
    // Verificar se o valor é válido e numérico
    if (value === null || value === undefined || value === '' || isNaN(value)) return 0;
    
    // Converter para número se for string
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    
    // Verificar se é um número válido
    if (isNaN(numValue) || numValue === 0) return 0;
    
    // Arredondar para maxDecimals casas decimais usando Math.round para evitar problemas de precisão
    const factor = Math.pow(10, maxDecimals);
    const rounded = Math.round(numValue * factor) / factor;
    
    // Converter para string e depois para número para remover zeros à direita
    // Exemplo: 1.230 vira 1.23, 1.234 fica 1.234
    const result = parseFloat(rounded.toString());
    
    return result;
};

export const valueWithIva = (value, percentage) => {
    const result = parseFloat(value) + (parseFloat(value) * ((parseFloat(percentage) / 100)));
    return smartRound(result, 9); // Usar 9 casas decimais para máxima precisão
}

export const valueWithoutIva = (value, percentage) => {
    if (percentage === null || percentage === undefined || percentage === '') return '';
    const result = parseFloat(value) / (1 + (parseFloat(percentage) / 100));
    return smartRound(result, 9); // Usar 9 casas decimais para máxima precisão
}

export const threeDecimal = (value) => {
    if (value === null || value === undefined || value === '') return '';
    return smartRound(value);
}

export const twoDecimal = (value) => {
    if (value === null || value === undefined || value === '') return '';
    return smartRound(value, 2);
}

export const applyDiscount = (value, descPer) => {
    const discount = descPer ? value * (descPer / 100) : 0;
    const result = value - discount;
    return smartRound(result);
}

export const revertDiscount = (discountedValue, descPer) => {
    const result = descPer ? discountedValue / (1 - descPer / 100) : discountedValue;
    return smartRound(result);
};

export const numberWithCommas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');